try {
  var firstLoad = true;
  var firstLoadreviews = true;
  window.wizzyVariantMap = window.wizzyVariantMap || {};
  const headerInput = document.querySelector('header input');
  if (window.innerWidth > 1025) {
    headerInput.addEventListener('click', () => {
      setTimeout(() => {
        const wrapper = document.querySelector('.wizzy-autocomplete-wrapper.onLeft');
        if (wrapper) {
          const rect = headerInput.getBoundingClientRect();
          const currentTop = parseInt(wrapper.style.top || 0, 10);
          wrapper.style.top = (currentTop + 8) + 'px';
          // wrapper.style.setProperty('left', `${rect.left + rect.width / 2}px`, 'important');
          // wrapper.style.transform = 'translateX(-50%)';
        }
      }, 800);
    });
  }

  headerInput.addEventListener('click', () => {
    setTimeout(() => {
      const wrapper = document.querySelector('.wizzy-autocomplete-wrapper.onLeft');
      if (wrapper) {
        if (window.innerWidth > 1110) {
          wrapper.style.setProperty('left', `${window.innerWidth / 5.05}px`, 'important');
        }
        if (window.innerWidth >= 768 && window.innerWidth <= 1110) {
          wrapper.style.setProperty('left', `${window.innerWidth / 7.8}px`, 'important');
        }
      }
    }, 800);
  });

//   const input = document.querySelector('#searchInput');
// const wrapper = document.querySelector('.wizzy-autocomplete-wrapper');

// if (input) {
//   input.addEventListener('focus', () => {
//     setTimeout(() => {
//       window.scrollTo(0, 0);

//       const mobileWrapper = document.querySelector('.wizzy-autocomplete-wrapper');
//       if (mobileWrapper) {
//         mobileWrapper.style.position = 'fixed';
//         mobileWrapper.style.top = '0';
//       }
//     }, 300);
//   });
// }

  if(window.innerWidth < 768){
    const input = document.querySelector('#searchInput');
    if (input) {
      input.addEventListener('touchstart', (e) => {
        e.stopPropagation();
      }, { passive: true });

      input.addEventListener('touchmove', (e) => {
        e.preventDefault();
        e.stopPropagation();
      }, { passive: false });
    }

    const searchFormWrapper = document.querySelector('.wizzy-search-form-wrapper.mobileTapped');
    if (searchFormWrapper) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.documentElement.style.overflow = 'hidden';
    }

    if (window.visualViewport) {
      const adjustWrapperHeight = () => {
        const wrapper = document.querySelector('.wizzy-autocomplete-wrapper');
        const input = document.querySelector('#searchInput');

        if (!wrapper || !input) return;

        const inputRect = input.getBoundingClientRect();
        const availableHeight = window.visualViewport.height - inputRect.bottom - 10 + 50;

        const isKeyboardOpen = window.visualViewport.height < window.innerHeight * 0.75;

        if (isKeyboardOpen) {
          wrapper.style.maxHeight = `${availableHeight}px`;
          wrapper.style.overflowY = 'auto';
        } else {
          wrapper.style.maxHeight = '';
          wrapper.style.overflowY = '';
        }
      };

      window.visualViewport.addEventListener('resize', adjustWrapperHeight);
      window.visualViewport.addEventListener('scroll', adjustWrapperHeight);

      const observer = new MutationObserver(() => {
        adjustWrapperHeight();
      });

      const wrapper = document.querySelector('.wizzy-autocomplete-wrapper');
      if (wrapper) {
        observer.observe(wrapper, {
          childList: true,
          subtree: true
        });
      }


      const input = document.querySelector('#searchInput');
      if (input) {
        input.addEventListener('input', () => {

          setTimeout(adjustWrapperHeight, 1500);
          const autocompleteTextWrappers = document.querySelectorAll('.autocomplete-text-wrapper');

          if (autocompleteTextWrappers.length > 0) {
            autocompleteTextWrappers.forEach((wrapper) => {
              wrapper.addEventListener('click', (e) => {
                setTimeout(() => {
                  adjustWrapperHeight();
                }, 1500);
              });
            });
          }

        });
      }
    }
  }

  // headerInput.addEventListener('input', () => {
  //   setTimeout(() => {
  //     const wrapper = document.querySelector('.wizzy-autocomplete-wrapper.onLeft');
  //     if (wrapper) {
  //       const rect = headerInput.getBoundingClientRect();
  //       const currentTop = parseInt(wrapper.style.top || 0, 10);
  //       wrapper.style.top = (currentTop + 8) + 'px';
  //       wrapper.style.left = `${rect.left + rect.width / 2}px`;
  //       wrapper.style.transform = 'translateX(-50%)';
  //     }
  //   }, 600);
  // });
  // window.wizzyConfig.search.configs.pagination.type = "numbered";

  window.addEventListener("scroll", () => {
    const wrapper = document.querySelector(".wizzy-autocomplete-wrapper");


    if (window.scrollY > 0) {
      localStorage.setItem("hasScrolled", "true");
      document.body.classList.add("scroll-happened");
    } else {
      document.body.classList.remove("scroll-happened");
      localStorage.removeItem("hasScrolled");
    }
  });



  var isFirstLoad = true;
  if (window.innerWidth > 768)
    document.querySelector('#header-search > input')?.remove();


  window.addEventListener("load", () => {
    if (window.wizzyConfig?.common?.isOnCategoryPage) {
      const pageKey = "scrollPositionInitialized_" + window.location.pathname;

      if (!sessionStorage.getItem(pageKey)) {
        sessionStorage.setItem("scrollPosition", 0);
        sessionStorage.setItem(pageKey, "true");
      }
    }
  });


  let scrollSaveTimeout;

  window.addEventListener('scroll', function () {
    clearTimeout(scrollSaveTimeout);
    scrollSaveTimeout = setTimeout(function () {
      sessionStorage.setItem('scrollPosition', window.pageYOffset);
    }, 100);
  });

  function showScrollRestoreLoader() {
    const overlay = document.createElement('div');
    overlay.id = 'scroll-restore-loader';
    overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.95);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 9999;
    `;

    overlay.innerHTML = `
        <div style="text-align: center;">
            <div style="
                border: 4px solid #f3f3f3;
                border-top: 4px solid #3498db;
                border-radius: 50%;
                width: 50px;
                height: 50px;
                animation: spin 1s linear infinite;
                margin: 0 auto 20px;
            "></div>
            <p style="font-size: 16px; color: #333; margin: 0;">Loading Products ...</p>
        </div>
        <style>
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
        </style>
    `;

    document.body.appendChild(overlay);
    return overlay;
  }

  function hideScrollRestoreLoader() {
    const overlay = document.getElementById('scroll-restore-loader');
    if (overlay) {
      overlay.style.opacity = '0';
      overlay.style.transition = 'opacity 0.3s ease';
      setTimeout(() => overlay.remove(), 300);
    }
  }

  function restoreScrollWithAutoLoad() {
    const scrollPosition = sessionStorage.getItem('scrollPosition');

    if (scrollPosition) {
      const targetScroll = parseInt(scrollPosition);
      const loader = showScrollRestoreLoader();

      window.scrollTo(0, targetScroll);

      setTimeout(() => {
        const actualScroll = window.pageYOffset;

        if (Math.abs(actualScroll - targetScroll) > 100) {
          smartScrollToPosition(targetScroll, loader);
        } else {
          hideScrollRestoreLoader();
        }
      }, 300);
    }
  }

  function smartScrollToPosition(targetPosition, loader) {
    let attempts = 0;
    const maxAttempts = 8;
    let lastHeight = 0;
    let sameHeightCount = 0;

    function attemptScroll() {
      attempts++;
      const currentHeight = document.documentElement.scrollHeight;
      const maxScrollable = currentHeight - window.innerHeight;
      const currentScroll = window.pageYOffset;

      if (attempts >= maxAttempts) {
        window.scrollTo(0, Math.min(targetPosition, maxScrollable));
        hideScrollRestoreLoader();
        return;
      }

      if (currentHeight === lastHeight) {
        sameHeightCount++;
        if (sameHeightCount >= 2) {
          window.scrollTo(0, Math.min(targetPosition, maxScrollable));
          hideScrollRestoreLoader();
          return;
        }
      } else {
        sameHeightCount = 0;
      }

      lastHeight = currentHeight;

      if (targetPosition <= maxScrollable) {
        window.scrollTo(0, targetPosition);
        hideScrollRestoreLoader();
        return;
      }

      if (Math.abs(currentScroll - targetPosition) <= 200) {
        hideScrollRestoreLoader();
        return;
      }

      window.scrollTo(0, maxScrollable);
      setTimeout(attemptScroll, 1200);
    }

    attemptScroll();
  }

  if (window.innerWidth > 768) {
    window.addEventListener('load', () => {
      const currentPath = window.location.pathname;
      const lastPath = sessionStorage.getItem('lastVisitedPath');

      const navigationType = performance.getEntriesByType('navigation')[0]?.type;
      const isReload = navigationType === 'reload';

      const isSamePageReload = lastPath === currentPath && isReload;
      if (currentPath === "/pages/search") {
        restoreScrollWithAutoLoad();
      }
      if (
          isSamePageReload && window.wizzyConfig?.common?.isOnCategoryPage
      ) {
        restoreScrollWithAutoLoad();
      }

      sessionStorage.setItem('lastVisitedPath', currentPath);
    });
  }



  var lastClickedFilter = null;

  let searchinput = document.querySelector('.t4s-search-header__input.t4s-input__currentcolor');
  if (searchinput) {
    searchinput.addEventListener('click', function () {
    });
  }

  function addlisterforquickwhislist() {
    setTimeout(() => {

      const qvButtons = document.querySelectorAll(".autocomplete-top-products .product-quickviews-btn");
      const addtocart = document.querySelectorAll(".autocomplete-top-products .new-collection__add");
      const whislistbutton = document.querySelectorAll(".autocomplete-top-products .swym-icon");
      if (qvButtons) {
        qvButtons.forEach(btn => {
          btn.removeEventListener("click", window.handleQvClick);
          btn.addEventListener("click", window.handleQvClick);
        });
      }
      if (addtocart) {
        addtocart.forEach(btn => {
          btn.removeEventListener("click", window.handleQvClick);
          btn.addEventListener("click", window.handleQvClick);
        });
      }

      if (whislistbutton) {
        whislistbutton.forEach(btn => {
          btn.removeEventListener("click", window.handleWishlistClick);
          btn.addEventListener("click", window.handleWishlistClick);
        });
      }
    }, 500);


  }

  function gridFiltersToggleOnOverflow() {
    if (window.innerWidth > 768) {
      const filterBoxes = document.querySelectorAll(".wizzy-grid-filters-box");

      if (filterBoxes.length > 0) {
        filterBoxes.forEach((box) => {
          const filterList = box.querySelector(
              ".wizzy-facet-body .wizzy-facet-list"
          );
          const toggleBtn = box.querySelector(
              ".wizzy-facet-body .wizzy-toggle-btn"
          );
          const filterOptions = box.querySelector(".wizzy-facet-body");

          if (
              filterList &&
              toggleBtn &&
              filterOptions &&
              !toggleBtn.classList.contains("wizzy-click-event-attached")
          ) {
            const filterHeight = filterList.offsetHeight;
            const lineHeight = parseFloat(
                getComputedStyle(filterList).lineHeight
            );
            const maxVisibleLines = 3;
            const visibleLines = Math.floor(filterHeight / lineHeight) - 1;


            if (visibleLines > maxVisibleLines) {
              filterOptions.classList.add("collapsed");
              toggleBtn.classList.add("wizzy-click-event-attached");
              toggleBtn.style.display = "inline-block";
            } else {
              toggleBtn.style.display = "none";
            }

            toggleBtn.addEventListener("click", function () {
              if (filterOptions.classList.contains("collapsed")) {
                filterOptions.classList.remove("collapsed");
                filterOptions.classList.add("expanded");
                toggleBtn.innerText = "- Less";
              } else {
                filterOptions.classList.remove("expanded");
                filterOptions.classList.add("collapsed");
                toggleBtn.innerText = "+ More";
              }
              toggleBtn.classList.add("wizzy-click-event-attached");
            });
          }
        });
      }
    }
  }

  function renderDefaultVariantTitles() {
    if (!window.wizzyVariantMap) return;

    var nodes = document.querySelectorAll('.wizzy-variant-title[data-variant-id]');
    if (!nodes.length) return;

    nodes.forEach(function (node) {
      var vid = node.getAttribute('data-variant-id');
      if (!vid) return;

      var variant = window.wizzyVariantMap[vid];
      if (!variant || !variant.title) return;

      if (!node.dataset.rendered) {
        node.textContent = variant.title;
        node.dataset.rendered = 'true';
      }
    });
  }


  window.onWizzyScriptLoaded = function () {
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
        function (data) {
          try {
            if (data.api === "autocomplete") {
              const query = data?.response?.payload?.products?.filters?.q || "";
              const requestId = data?.requestId || "";
              setTimeout(() => {
                const queryElement = document.querySelector('.wizzy-autocomplete-wrapper.onLeft .wizzy-empty-searched-query');
                const refIdElement = document.querySelector('.wizzy-autocomplete-wrapper.onLeft .wizzy-req-ref-id');

                if (queryElement) queryElement.textContent = query;
                if (refIdElement) refIdElement.textContent = `Ref ID: ${requestId}`;
              }, 200);


              data?.response?.payload?.categories?.forEach((category) => {
                if (category.filters.categories[0].includes("_wzAc")) {
                  category.payload.forEach((item) => {
                    if (item.key === "relatedCategories") {
                      item.value[0].url = undefined;
                    }
                  })
                }
              })
            }
          } catch (error) {
            console.log("wizzy error", error)
          }

          return data;
        }
    );


    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
        function (data) {
          try {
            const filterItems = document.querySelectorAll('.wizzy-facet-list-item');
            filterItems.forEach((item) => {
              item.addEventListener('click', () => {
                lastClickedFilter = item;
                if (lastClickedFilter) {
                  setTimeout(() => {

                    lastClickedFilter.scrollIntoView({
                      behavior: "instant",
                      block: "center"
                    });
                  }, 500);
                }
              });
            });
            if (window.innerWidth > 768) {
              let searchicon = document.querySelectorAll('.facet-head-search-icon');

              if (searchicon) {
                searchicon.forEach((icon) => {
                  icon.click();
                });

              }
            }
            document.body.classList.remove('t4s-lock-scroll');
            const qvButtons = document.querySelectorAll(".product-quickviews-btn");
            const addtocart = document.querySelectorAll(".new-collection__add");
            const whislistbutton = document.querySelectorAll(".wishlist-btn.wishlist-btn-loader-app.wishlist-btn-list")
            if (qvButtons) {
              qvButtons.forEach(btn => {
                btn.removeEventListener("click", window.handleQvClick); // avoid duplicates
                btn.addEventListener("click", window.handleQvClick);
              });
            }
            if (addtocart) {
              addtocart.forEach(btn => {
                btn.removeEventListener("click", window.handleQvClick); // avoid duplicates
                btn.addEventListener("click", window.handleQvClick);
              });
            }

            if (whislistbutton) {
              whislistbutton.forEach(btn => {
                btn.removeEventListener("click", window.handleWishlistClick); // avoid duplicates
                btn.addEventListener("click", window.handleWishlistClick);
              });
            }


            gridFiltersToggleOnOverflow();

          } catch (error) {
            console.log("error",error);
          }

          return data;
        });
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
        function (data) {
          if (data.group === "defaultMenu") {
            data.filters.sort = [{
              field: "product_bestseller-new_sortOrder:float",
              order: "asc"
            }];
          }
          try {
            // if (data.group === "categoryPage" && window.wizzyConfig.common.collectionHandle.includes("samples")) {
            //   data.filters.getAllVariants = "true";
            //   data.filters.variantsGroupBy = "groupId";
            // }
            if (data.group === "categoryPage" && window.wizzyConfig.common.collectionHandle.includes("gift-set")) {
              data.filters.getAllVariants = "true";
              data.filters.variantsGroupBy = "groupId";
            }
            // if (data.group === "categoryPage" && window.wizzyConfig.common.collectionHandle.includes("travel")) {
            //   data.filters.getAllVariants = "true";
            //   data.filters.variantsGroupBy = "groupId";
            // }
            // if (window.wizzyConfig?.common?.isOnCategoryPage) {
            //   delete data?.filters?.boostGroupIds;
            // }

            // data.filters.showOOSProductsInOrder = "true";
            // if (!data.filters.sort.length || data.filters.sort[0].field !== "relevance" && window.wizzyConfig.common.isOnCategoryPage && isFirstLoad) {
            //   data.filters.sort.unshift({
            //     field: "relevance",
            //     order: "asc"
            //   });
            //   isFirstLoad = false;
            // }
            // if (window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle.includes('travel') && firstLoad) {
            //   if (data?.filters?.sort?.length) {
            //     data.filters.sort.push(

            //         { field: "product_travel:float", order: "desc", isForParent: !1 },
            //         { field: "product_sale_badge:float", order: "desc", isForParent: !1 },
            //         { field: "product_tester:float", order: "desc", isForParent: !1 },
            //         { field: "product_size_standard:float", order: "desc", isForParent: !1 },
            //         { field: "product_size_larger:float", order: "desc", isForParent: !1 },
            //         { field: "product_size_smaller:float", order: "desc", isForParent: !1 }
            //     );
            //   }
            //   firstLoad = false;
            // }
            // else if (window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle.includes('samples') && firstLoad) {
            //   if (data?.filters?.sort?.length) {
            //     data.filters.sort.push(

            //         { field: "product_sample:float", order: "desc" },
            //         { field: "product_sale_badge:float", order: "desc" },
            //         { field: "product_size_standard:float", order: "desc" },
            //         { field: "product_size_larger:float", order: "desc" },
            //         { field: "product_size_smaller:float", order: "desc" },
            //         { field: "product_tester:float", order: "desc" }
            //         // { field: "product_wizzy-best-selling_sortOrder:float", order: "asc", isForParent: !1 },
            //     );
            //   }
            //   firstLoad = false;
            // }
            // else if (window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle.includes("gift-set") && firstLoad) {
            //   if (data?.filters?.sort?.length) {
            //     data.filters.sort.push(

            //         { field: "product_gift_sets:float", order: "desc", isForParent: !1 },
            //         { field: "product_sale_badge:float", order: "desc", isForParent: !1 },
            //         { field: "product_size_standard:float", order: "desc", isForParent: !1 },
            //         { field: "product_size_larger:float", order: "desc", isForParent: !1 },
            //         { field: "product_size_smaller:float", order: "desc", isForParent: !1 },
            //         { field: "product_tester:float", order: "desc", isForParent: !1 }
            //     );
            //   }
            //   firstLoad = false;
            // }
          if (window.wizzyConfig.common.isOnCategoryPage && firstLoad) {
            if (data?.filters?.sort?.length) {

              const relevanceSort = data.filters.sort.find(s => s.field === "relevance");
              let otherSorts = data.filters.sort.filter(s => s.field !== "relevance");

              const bestSelling = otherSorts.find(s =>
                s.field === "product_wizzy-best-selling_sortOrder:float"
              );
              otherSorts = otherSorts.filter(s =>
                s.field !== "product_wizzy-best-selling_sortOrder:float"
              );

              const customSorts = [
                { field: "product_sale_badge:float", order: "desc", isForParent: false },
                { field: "product_size_standard:float", order: "desc", isForParent: false },
                { field: "product_size_larger:float", order: "desc", isForParent: false },
                { field: "product_size_smaller:float", order: "desc", isForParent: false },
                { field: "product_tester:float", order: "desc", isForParent: false },
                { field: "product_gift_sets:float", order: "desc", isForParent: false }
              ];

              // Step 4: rebuild order
              data.filters.sort = [
                relevanceSort,
                ...customSorts,
                ...otherSorts,
                ...(bestSelling ? [bestSelling] : [])
              ];
            }

            firstLoad = false;
          }



          } catch (error) {
            console.log("error", error);
          }


          return data;
        }, 4);

            window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
        function (data) {
         if (data?.sort?.length) {
            data.sort.push(
                { field: "product_sale_badge:float", order: "desc", isForParent: !1 },
                { field: "product_tester:float", order: "desc", isForParent: !1 },
                { field: "product_size_standard:float", order: "desc", isForParent: !1 },
                { field: "product_size_larger:float", order: "desc", isForParent: !1 },
                { field: "product_size_smaller:float", order: "desc", isForParent: !1 },
                { field: "product_gift_sets:float", order: "desc", isForParent: !1 },
      );
      }

        return data;
        },3);
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
        function (data) {

          data.filters.configs.layout = "v1";
          data.search.configs.general.minQueryLength = 1;
          data.filters.configs.keepOpenedInMobileAfterApply = !0;
          if (window.wizzyConfig.common.isOnCategoryPage) {

            data.search.configs.sorts.configs = data.search.configs.sorts.configs.filter(
                item => item.field !== "product_wizzy-best-selling_sortOrder:float"
            );

            data.search.configs.sorts.configs.forEach(item => {
              if (item.field === "relevance") {
                item.label = "Best Seller";
              }
            });

          }
          window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
            desktop: 5000,
            mobile: 5000
          }
          window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
          if (window.innerWidth < 768) {

            data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
              "dom": "#searchInput",
              "type": "text"
            };
          }
          return data;
        }, 1);
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
        function (data) {
          data.filters.configs.layout = "v1";
          data.filters.configs.keepOpenedInMobileAfterApply = !0;
          data.search.configs.facets.leftFacets.mobileCollapsible = true;
          window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
            desktop: 5000,
            mobile: 5000
          }
          if (window.innerWidth < 768) {

            data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
              "dom": "#searchInput",
              "type": "text"
            };
          }
          else {
            data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
              "dom": "header input",
              "type": "text"
            };
          }
          return data;
        }, 1);

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
        function (data) {

          if (document.querySelector('#shopify-section-template--22659878289716__hero_image_VFDnLB')) {
            document.querySelector('#shopify-section-template--22659878289716__hero_image_VFDnLB').style.display = "none";
          }

          if (document.querySelector('#shopify-section-template--22659878289716__new_col_UDFwN3')) {
            document.querySelector('#shopify-section-template--22659878289716__new_col_UDFwN3').style.display = "none";
          }
          const sections = document.querySelectorAll("#MainContent > section");

          sections?.forEach(section => {
            const id = section.id || "";

            // Check if the ID includes any of the target substrings
            if (
                id.includes("collection_title") ||
                id.includes("banner") ||
                id.includes("discover_more")
            ) {
              section.style.display = "none";
            }
          });



          const wizzy_back_button = document.querySelector('.wizzy-search-back');
          if (wizzy_back_button) {
            wizzy_back_button.click();
          }

         if (data?.sort?.length) {
            data.sort.push(
                { field: "product_sale_badge:float", order: "desc", isForParent: !1 },
                { field: "product_tester:float", order: "desc", isForParent: !1 },
                { field: "product_size_standard:float", order: "desc", isForParent: !1 },
                { field: "product_size_larger:float", order: "desc", isForParent: !1 },
                { field: "product_size_smaller:float", order: "desc", isForParent: !1 },
                { field: "product_gift_sets:float", order: "desc", isForParent: !1 },
      );
      }
          return data;
        });

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
        function (data) {
          try {
            if (data.api === "search" || data.api === "filter") {
              var facets = data?.response?.payload?.facets;
              for (let i = 0; i < facets.length; i++) {
                if (facets[i].key === "brands") {
                  let data = facets[i]?.data;
                  if (data) {
                    data.sort((a, b) => a.key.localeCompare(b.key));
                    facets[i].data = data;
                  }
                }
              }
            }
            let facets1 = data.response?.payload?.facets;

            facets1?.forEach((facet, index) => {
              if (Array.isArray(facet.data) && facet.data.length <= 1) {
                facets1.splice(index, 1);
              }
            });

            data.response.payload.facets = facets1;
            const facets2 = data?.response?.payload?.facets || [];

            facets2.forEach(facet => {
              if (facet.key === "product_reviews_average_yotpo") {
                facet.data.sort((a, b) => {
                  const aVal = parseFloat(a.label);
                  const bVal = parseFloat(b.label);
                  return bVal - aVal;
                });

              }
            });

          } catch (error) {
            console.log("error", error);
          }

          return data;
        }
    );

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
        function (products) {

          try {
            products.forEach((product) => {
              product.attributes?.forEach((attr) => {
                if (attr.id === "product_fregrance_type_custom") {
                  let fragrance_type = attr.values[0]?.value[0];
                  product.fragranceType = fragrance_type;
                }

                if (attr.id === "product_variant_prices") {
                  const inStockPrices = attr.values
                      .filter(v => v.inStock)
                      .map(v => v.value[0]);

                  // if (inStockPrices.length > 1) {
                  //   const minPrice = Math.min(...inStockPrices);
                  //   const maxPrice = Math.max(...inStockPrices);
                  //
                  //   product.priceRange =
                  //       minPrice === maxPrice
                  //           ? `${minPrice}`
                  //           : `${minPrice} - $${maxPrice}`;
                  // }
                }


                if (attr.id === "product_product_name_custom") {
                  let product_name = attr.values[0]?.value[0];
                  product.productType = product_name;
                }

                if (attr.id === "product_sale_custom") {
                  if (attr.values[0]?.value[0] === "Yes") {
                    let issale = attr.values[0]?.value[0];
                    product.isSale = issale;
                    let discount = (product.sellingPrice * 15) / 100;
                    let discounted = product.sellingPrice - discount;
                    product.discountedPrice = (Math.ceil(discounted * 100) / 100).toFixed(2);
                  }
                }

                if (attr.id === "product_product_badges_custom") {
                  product.isBadge = true;
                  attr.values.forEach(val => {
                    if (val.value[0] === "BESTSELLER")
                      product.bestSeller = true;

                    if (val.value[0] === "RARE FIND")
                      product.rareFind = true;

                    if (val.value[0] === "SALE")
                      product.sale = true;

                  });
                }

                // if (attr.id ===  "product_product_category_custom") {
                //   product.gender= attr.values[0].value[0];
                // }
                if (attr.id === "product_reviews_average_yotpo") {
                  const avg = parseInt(attr.values[0].value[0], 10);
                  if (avg > 0) {
                    product.reviews = avg;
                    product.stars = Array.from({ length: 5 }, (_, i) => ({
                      filled: i < product.reviews
                    }));
                  }
                }


                if (attr.id === "product_reviews_count_yotpo") {
                  const count = parseInt(attr.values[0].value[0], 10);
                  if (count > 0) {
                    product.reviews_count = count;
                  }
                }


                if (attr.id === "product_handle") {
                  product.handle = attr.values[0].value[0];
                }

              });
              if (
                  product?.swatches &&
                  product?.swatches[0]?.values?.filter(v => v.inStock).length > 0
              ) {
                product.checkedPrice = true;
                if (
                    product?.swatches &&
                    product?.swatches[0] &&
                    Array.isArray(product.swatches[0].values)
                ) {

                  const firstInStock = product.swatches[0].values.find(v => v.inStock) || product.swatches[0].values[0];

                  if (firstInStock) {
                    product.defaultVariantTitle =
                        firstInStock.label ||
                        (Array.isArray(firstInStock.value) ? firstInStock.value[0] : firstInStock.value);
                  }

                  product.swatches[0].values.forEach(function (v) {
                    if (!v) return;
                    var variantId =
                        v.variationId ||
                        (Array.isArray(v.value) ? v.value[1] : null) ||
                        v.valueId;

                    var variantTitle =
                        v.label ||
                        (Array.isArray(v.value) ? v.value[0] : v.value) ||
                        v.name;

                    if (!variantId || !variantTitle) return;

                    window.wizzyVariantMap[variantId] = {
                      title: variantTitle,
                      productId: product.id,
                      handle: product.handle
                    };
                  });
                }
              } else {
                product.checkedPrice = false;
              }
              if (Number(product.price) < Number(product.sellingPrice)) {
                product.sellingPriceGreater = true;
                product.isOnSale = false;
              } else {
                product.sellingPriceGreater = false;
                product.isOnSale = true;
              }



            });
          }
          catch (e) {
            console.log(e);
          }
          return products;
        });
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
        function (data) {
          try {
            gridFiltersToggleOnOverflow();

            renderDefaultVariantTitles();
            if (window.innerWidth > 768) {
              let searchicons = document.querySelectorAll('.facet-head-search-icon');

              if (searchicons.length > 0) {
                setTimeout(() => {
                  searchicons.forEach((icon) => {
                    const wrapper = icon.closest('.facet-search-wrapper');
                    // ✅ Only click if wrapper does NOT have 'active' class
                    if (wrapper && !wrapper.classList.contains('active')) {
                      icon.click();
                    }
                  });
                }, 500);
              }
            }
            const firstFilterBlock = document.querySelector(".wizzy-search-filters-left-wrapper .wizzy-facet-list-block .wizzy-filters-facet-block");
            firstFilterBlock && firstFilterBlock.classList.contains("first-opened") && firstFilterBlock.classList.remove("collapsed");

            let viewmorebuttons = document.querySelectorAll('.wizzy-autocomplete-top-products-view-more');
            let totalResults = data?.data?.response?.payload?.products?.total;

            if (viewmorebuttons.length && totalResults) {
              viewmorebuttons.forEach(button => {
                button.textContent = `VIEW ALL ${totalResults} RESULTS`;
              });
            }
            if(window.innerWidth < 768){
              document.querySelector('.wizzy-apply-all-button-v1').addEventListener('click',()=>{
                document.querySelector('.wizzy-filters-close-btn').click();
              });
            }
            if (window.innerWidth < 768) {
              const wrapper = document.querySelector(".wizzy-search-summary-container");
              const applyallbtn = document.querySelector('.wizzy-mobile-filter-buttons .wizzy-apply-all-button-v1');
              if (applyallbtn) {
                const total = data?.data?.response?.payload?.total || 0;
                applyallbtn.textContent = `SHOW RESULTS (${total})`;
              }

              if (wrapper && wrapper.innerHTML.trim() === "") {
                const total = data?.data?.response?.payload?.total || 0;
                const query = data?.data?.response?.payload?.filters?.q || "";

                if (!window.wizzyConfig.common.isOnCategoryPage) {
                  wrapper.innerHTML = `
                  <p class="wizzy-summary-head">${total} Results found for <strong>"${query}"</strong>:</p>
                `;
                }
                else if (window.wizzyConfig.common.isOnCategoryPage) {
                  wrapper.innerHTML = `
                    <p class="wizzy-summary-head">${total} Products</p>
                  `;
                  if (total === 20000) {
                    wrapper.innerHTML = `
                    <p class="wizzy-summary-head"> </p>
                  `;
                  }
                }
              }
            }

            if (window.innerWidth > 768) {
              const wrapper = document.querySelector(".wizzy-search-summary-container");


              if (wrapper && wrapper.innerHTML.trim() === "") {
                const total = data?.data?.response?.payload?.total || 0;
                const query = data?.data?.response?.payload?.filters?.q || "";
                if (window.wizzyConfig.common.isOnCategoryPage) {
                  wrapper.innerHTML = `
                  <p class="wizzy-summary-head">${total}  Products</p>
                `;
                  if (total === 20000) {
                    wrapper.innerHTML = `
                    <p class="wizzy-summary-head"> </p>
                  `;
                  }

                  const summary = document.querySelector('.wizzy-search-summary-wrapper');
                  const filtersTop = document.querySelector('.wizzy-search-filters-top');

                  if (summary && filtersTop) {
                    filtersTop.insertBefore(summary, filtersTop.firstChild);
                  }
                }

              }
              if (!window.wizzyConfig.common.isOnCategoryPage) {

                const summary = document.querySelector('.wizzy-search-summary-wrapper');
                const filtersTop = document.querySelector('.wizzy-search-filters-top');

                if (summary && filtersTop) {
                  filtersTop.insertBefore(summary, filtersTop.firstChild);
                }
              }


            }


            const filterContainerSelector = '.wizzy-search-filters-left';
            if (filterContainerSelector) {
              const filterItems = document.querySelectorAll('.wizzy-facet-list-item');
              const filterContainer = document.querySelector(filterContainerSelector);
              if (filterItems && filterContainer) {
                filterItems.forEach((item) => {
                  item.addEventListener('click', () => {
                    if (filterContainer) {
                      localStorage.setItem('wizzyFilterScrollTop', filterContainer.scrollTop);
                    }
                  });
                });
              }
              const savedScroll = localStorage.getItem('wizzyFilterScrollTop');
              if (savedScroll !== null && filterContainer) {
                setTimeout(() => {
                  filterContainer.scrollTop = parseInt(savedScroll, 10);
                }, 100);
              }
            }


            document.body.classList.remove('t4s-lock-scroll');
            const qvButtons = document.querySelectorAll(".product-quickviews-btn");
            const addtocart = document.querySelectorAll(".new-collection__add");
            const whislistbutton = document.querySelectorAll(".swym-icon.swym-heart ")
            if (qvButtons) {
              qvButtons.forEach(btn => {

                btn.removeEventListener("click", window.handleQvClick);
                btn.addEventListener("click", window.handleQvClick);
              });
            }
            if (addtocart) {
              addtocart.forEach(btn => {
                btn.removeEventListener("click", window.handleQvClick);
                btn.addEventListener("click", window.handleQvClick);
              });
            }

            if (whislistbutton) {
              whislistbutton.forEach(btn => {
                btn.removeEventListener("click", window.handleWishlistClick);
                btn.addEventListener("click", window.handleWishlistClick);
              });
            }

            document.querySelectorAll('.facet-body-product_reviews_average_yotpo .wizzy-facet-list li.wizzy-facet-list-item').forEach(li => {
              const labelEl = li.querySelector('.facet-item-label-value');
              if (!labelEl) return;
              if (li.querySelector('[class*="tw-flex"][class*="tw-items-center"][class*="tw-gap-0.5"]')) return;


              const labelText = labelEl.textContent.trim();
              const rating = parseInt(labelText);
              if (!rating || isNaN(rating)) return;

              const starsWrapper = document.createElement('div');
              starsWrapper.className = 'tw-flex tw-items-center tw-gap-0.5';

              const starSVG = `
                <svg class="tw-size-3 tw-flex-shrink-0 tw-fill-black" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1731_35834)">
                    <path d="M6 1.17993C6.06593 1.17999 6.10113 1.21003 6.1123 1.23267L7.55566 4.15845L7.61426 4.27661L7.74414 4.29517L10.9727 4.76392C11.0198 4.77095 11.0585 4.80453 11.0732 4.84985C11.0874 4.89376 11.0763 4.94246 11.042 4.97681L8.70605 7.25415L8.6123 7.34595L8.63379 7.47583L9.18555 10.6917C9.19345 10.7386 9.17426 10.7857 9.13574 10.8137C9.11467 10.8291 9.08884 10.8381 9.0625 10.8381C9.0427 10.8381 9.02285 10.8329 9.00488 10.8235L6.11621 9.30493L6 9.24341L5.88379 9.30493L2.99609 10.8225L2.99512 10.8235C2.9536 10.8455 2.90244 10.8416 2.86426 10.8137L2.83887 10.7893C2.81761 10.7621 2.80865 10.7267 2.81445 10.6917L3.36621 7.47485L3.3877 7.34595L3.29395 7.25415L0.957031 4.97681C0.923193 4.94309 0.911636 4.89352 0.925781 4.84985C0.936977 4.8156 0.962335 4.78803 0.994141 4.77368L1.02734 4.76392L4.25586 4.29517L4.38574 4.27661L4.44434 4.15845L5.8877 1.23267C5.89888 1.21001 5.93395 1.17993 6 1.17993Z" stroke="black" stroke-width="0.5"></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_1731_35834">
                      <rect width="12" height="12"></rect>
                    </clipPath>
                  </defs>
                </svg>`;

              for (let i = 1; i <= 5; i++) {
                const star = document.createElement('div');
                star.innerHTML = starSVG;
                const svg = star.firstElementChild;

                if (i > rating) {
                  svg.classList.remove('tw-fill-black');
                  svg.setAttribute('fill', 'none');
                }

                starsWrapper.appendChild(svg);
              }

              labelEl.parentElement.insertBefore(starsWrapper, labelEl);
            });
            firstLoadreviews = false;



            if (window.innerWidth > 768) {
              const selectedFiltersBlock = document.querySelector(".wizzy-selected-filters");
              const facetListBlock = document.querySelector(".wizzy-facet-list-block");
              const existingFacetHead = document.querySelector(".wizzy-facet-head.selected-filter");

              if (selectedFiltersBlock && facetListBlock && existingFacetHead) {
                existingFacetHead.addEventListener("click", () => {
                  selectedFiltersBlock.classList.toggle("open");
                  existingFacetHead.classList.toggle("open");
                });

                // facetListBlock.insertBefore(selectedFiltersBlock, facetListBlock.firstChild);

                const ul = selectedFiltersBlock.querySelector(".wizzy-selected-facet-list");
                const liItems = ul ? ul.querySelectorAll("li") : [];

                if (liItems.length > 0) {
                  const appliedText = `${liItems.length} Applied Filter${liItems.length > 1 ? "s" : ""}`;

                  existingFacetHead.childNodes.forEach(node => {
                    const isTextNode = node.nodeType === Node.TEXT_NODE;
                    const isNonSvgElement = node.nodeType === Node.ELEMENT_NODE && node.tagName !== "SVG";

                    if (isTextNode || isNonSvgElement) {
                      existingFacetHead.removeChild(node);
                    }
                  });

                  const textNode = document.createTextNode(appliedText + " ");
                  const svgElement = existingFacetHead.querySelector("svg");

                  if(existingFacetHead && selectedFiltersBlock){
                    existingFacetHead.insertBefore(textNode, svgElement);
                    existingFacetHead.style.display = "flex";

                    selectedFiltersBlock.insertBefore(existingFacetHead, ul);
                  }
                }
              }

            }

            if (window.innerWidth < 768) {
              const selectedFiltersBlock = document.querySelector(".wizzy-selected-filters");
              const facetListBlock = document.querySelector(".wizzy-facet-list-block");
              const existingFacetHead = document.querySelector(".wizzy-facet-head.selected-filter");

              if (selectedFiltersBlock && facetListBlock && existingFacetHead) {
                existingFacetHead.addEventListener("click", () => {
                  selectedFiltersBlock.classList.toggle("open");
                  existingFacetHead.classList.toggle("open");
                });

                // facetListBlock.insertBefore(selectedFiltersBlock, facetListBlock.firstChild);

                const ul = selectedFiltersBlock.querySelector(".wizzy-selected-facet-list");
                const liItems = ul ? ul.querySelectorAll("li") : [];

                if (liItems.length > 0) {
                  const appliedText = `${liItems.length} Applied Filter${liItems.length > 1 ? "s" : ""}`;

                  existingFacetHead.childNodes.forEach(node => {
                    const isTextNode = node.nodeType === Node.TEXT_NODE;
                    const isNonSvgElement = node.nodeType === Node.ELEMENT_NODE && node.tagName !== "SVG";

                    if (isTextNode || isNonSvgElement) {
                      existingFacetHead.removeChild(node);
                    }
                  });

                  const textNode = document.createTextNode(appliedText + " ");
                  const svgElement = existingFacetHead.querySelector("svg");

                  if(existingFacetHead && selectedFiltersBlock){
                    existingFacetHead.insertBefore(textNode, svgElement);
                    existingFacetHead.style.display = "flex";

                    selectedFiltersBlock.insertBefore(existingFacetHead, ul);
                  }
                }
              }

            }





          }


          catch (error) {
            console.log("wizzy error", error);
          }

          return data;
        });


    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED, function (data) {
      try {
        gridFiltersToggleOnOverflow();
        renderDefaultVariantTitles();
        if (window.innerWidth > 768) {
          let searchicons = document.querySelectorAll('.facet-head-search-icon');

          if (searchicons.length > 0) {
            setTimeout(() => {
              searchicons.forEach((icon) => {
                const wrapper = icon.closest('.facet-search-wrapper');
                // ✅ Only click if wrapper does NOT have 'active' class
                if (wrapper && !wrapper.classList.contains('active')) {
                  icon.click();
                }
              });
            }, 500);
          }
        }
        const firstFilterBlock = document.querySelector(".wizzy-search-filters-left-wrapper .wizzy-facet-list-block .wizzy-filters-facet-block");
        firstFilterBlock && firstFilterBlock.classList.contains("first-opened") && firstFilterBlock.classList.remove("collapsed");

        let viewmorebuttons = document.querySelectorAll('.wizzy-autocomplete-top-products-view-more');
        let totalResults = data?.data?.response?.payload?.products?.total;

        if (viewmorebuttons.length && totalResults) {
          viewmorebuttons.forEach(button => {
            button.textContent = `VIEW ALL ${totalResults} RESULTS`;
          });
        }
        if(window.innerWidth < 768){
          document.querySelector('.wizzy-apply-all-button-v1').addEventListener('click',()=>{
            document.querySelector('.wizzy-filters-close-btn').click();
          });
        }
        if (window.innerWidth < 768) {
          const wrapper = document.querySelector(".wizzy-search-summary-container");
          const applyallbtn = document.querySelector('.wizzy-mobile-filter-buttons .wizzy-apply-all-button-v1');
          if (applyallbtn) {
            const total = data?.data?.response?.payload?.total || 0;
            applyallbtn.textContent = `SHOW RESULTS (${total})`;
          }

          if (wrapper && wrapper.innerHTML.trim() === "") {
            const total = data?.data?.response?.payload?.total || 0;
            const query = data?.data?.response?.payload?.filters?.q || "";

            if (!window.wizzyConfig.common.isOnCategoryPage) {
              wrapper.innerHTML = `
                  <p class="wizzy-summary-head">${total} Results found for <strong>"${query}"</strong>:</p>
                `;
            }
            else if (window.wizzyConfig.common.isOnCategoryPage) {
              wrapper.innerHTML = `
                    <p class="wizzy-summary-head">${total} Products</p>
                  `;
              if (total === 20000) {
                wrapper.innerHTML = `
                    <p class="wizzy-summary-head"> </p>
                  `;
              }
            }
          }
        }

        if (window.innerWidth > 768) {
          const wrapper = document.querySelector(".wizzy-search-summary-container");


          if (wrapper && wrapper.innerHTML.trim() === "") {
            const total = data?.data?.response?.payload?.total || 0;
            const query = data?.data?.response?.payload?.filters?.q || "";
            if (window.wizzyConfig.common.isOnCategoryPage) {
              wrapper.innerHTML = `
                  <p class="wizzy-summary-head">${total}  Products</p>
                `;
              if (total === 20000) {
                wrapper.innerHTML = `
                    <p class="wizzy-summary-head"> </p>
                  `;
              }

              const summary = document.querySelector('.wizzy-search-summary-wrapper');
              const filtersTop = document.querySelector('.wizzy-search-filters-top');

              if (summary && filtersTop) {
                filtersTop.insertBefore(summary, filtersTop.firstChild);
              }
            }

          }
          if (!window.wizzyConfig.common.isOnCategoryPage) {

            const summary = document.querySelector('.wizzy-search-summary-wrapper');
            const filtersTop = document.querySelector('.wizzy-search-filters-top');

            if (summary && filtersTop) {
              filtersTop.insertBefore(summary, filtersTop.firstChild);
            }
          }


        }


        const filterContainerSelector = '.wizzy-search-filters-left';
        if (filterContainerSelector) {
          const filterItems = document.querySelectorAll('.wizzy-facet-list-item');
          const filterContainer = document.querySelector(filterContainerSelector);
          if (filterItems && filterContainer) {
            filterItems.forEach((item) => {
              item.addEventListener('click', () => {
                if (filterContainer) {
                  localStorage.setItem('wizzyFilterScrollTop', filterContainer.scrollTop);
                }
              });
            });
          }
          const savedScroll = localStorage.getItem('wizzyFilterScrollTop');
          if (savedScroll !== null && filterContainer) {
            setTimeout(() => {
              filterContainer.scrollTop = parseInt(savedScroll, 10);
            }, 100);
          }
        }


        document.body.classList.remove('t4s-lock-scroll');
        const qvButtons = document.querySelectorAll(".product-quickviews-btn");
        const addtocart = document.querySelectorAll(".new-collection__add");
        const whislistbutton = document.querySelectorAll(".swym-icon.swym-heart ")
        if (qvButtons) {
          qvButtons.forEach(btn => {

            btn.removeEventListener("click", window.handleQvClick);
            btn.addEventListener("click", window.handleQvClick);
          });
        }
        if (addtocart) {
          addtocart.forEach(btn => {
            btn.removeEventListener("click", window.handleQvClick);
            btn.addEventListener("click", window.handleQvClick);
          });
        }

        if (whislistbutton) {
          whislistbutton.forEach(btn => {
            btn.removeEventListener("click", window.handleWishlistClick);
            btn.addEventListener("click", window.handleWishlistClick);
          });
        }

        document.querySelectorAll('.facet-body-product_reviews_average_yotpo .wizzy-facet-list li.wizzy-facet-list-item').forEach(li => {
          const labelEl = li.querySelector('.facet-item-label-value');
          if (!labelEl) return;
          if (li.querySelector('[class*="tw-flex"][class*="tw-items-center"][class*="tw-gap-0.5"]')) return;


          const labelText = labelEl.textContent.trim();
          const rating = parseInt(labelText);
          if (!rating || isNaN(rating)) return;

          const starsWrapper = document.createElement('div');
          starsWrapper.className = 'tw-flex tw-items-center tw-gap-0.5';

          const starSVG = `
                <svg class="tw-size-3 tw-flex-shrink-0 tw-fill-black" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1731_35834)">
                    <path d="M6 1.17993C6.06593 1.17999 6.10113 1.21003 6.1123 1.23267L7.55566 4.15845L7.61426 4.27661L7.74414 4.29517L10.9727 4.76392C11.0198 4.77095 11.0585 4.80453 11.0732 4.84985C11.0874 4.89376 11.0763 4.94246 11.042 4.97681L8.70605 7.25415L8.6123 7.34595L8.63379 7.47583L9.18555 10.6917C9.19345 10.7386 9.17426 10.7857 9.13574 10.8137C9.11467 10.8291 9.08884 10.8381 9.0625 10.8381C9.0427 10.8381 9.02285 10.8329 9.00488 10.8235L6.11621 9.30493L6 9.24341L5.88379 9.30493L2.99609 10.8225L2.99512 10.8235C2.9536 10.8455 2.90244 10.8416 2.86426 10.8137L2.83887 10.7893C2.81761 10.7621 2.80865 10.7267 2.81445 10.6917L3.36621 7.47485L3.3877 7.34595L3.29395 7.25415L0.957031 4.97681C0.923193 4.94309 0.911636 4.89352 0.925781 4.84985C0.936977 4.8156 0.962335 4.78803 0.994141 4.77368L1.02734 4.76392L4.25586 4.29517L4.38574 4.27661L4.44434 4.15845L5.8877 1.23267C5.89888 1.21001 5.93395 1.17993 6 1.17993Z" stroke="black" stroke-width="0.5"></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_1731_35834">
                      <rect width="12" height="12"></rect>
                    </clipPath>
                  </defs>
                </svg>`;

          for (let i = 1; i <= 5; i++) {
            const star = document.createElement('div');
            star.innerHTML = starSVG;
            const svg = star.firstElementChild;

            if (i > rating) {
              svg.classList.remove('tw-fill-black');
              svg.setAttribute('fill', 'none');
            }

            starsWrapper.appendChild(svg);
          }

          labelEl.parentElement.insertBefore(starsWrapper, labelEl);
        });
        firstLoadreviews = false;



        if (window.innerWidth > 768) {
          const selectedFiltersBlock = document.querySelector(".wizzy-selected-filters");
          const facetListBlock = document.querySelector(".wizzy-facet-list-block");
          const existingFacetHead = document.querySelector(".wizzy-facet-head.selected-filter");

          if (selectedFiltersBlock && facetListBlock && existingFacetHead) {
            if (!existingFacetHead.hasClickListener) {
              existingFacetHead.addEventListener("click", () => {
                selectedFiltersBlock.classList.toggle("open");
                existingFacetHead.classList.toggle("open");
              });
              existingFacetHead.hasClickListener = true; // mark as attached
            }


            // facetListBlock.insertBefore(selectedFiltersBlock, facetListBlock.firstChild);

            const ul = selectedFiltersBlock.querySelector(".wizzy-selected-facet-list");
            const liItems = ul ? ul.querySelectorAll("li") : [];

            if (liItems.length > 0) {
              const appliedText = `${liItems.length} Applied Filter${liItems.length > 1 ? "s" : ""}`;

              existingFacetHead.childNodes.forEach(node => {
                const isTextNode = node.nodeType === Node.TEXT_NODE;
                const isNonSvgElement = node.nodeType === Node.ELEMENT_NODE && node.tagName !== "SVG";

                if (isTextNode || isNonSvgElement) {
                  existingFacetHead.removeChild(node);
                }
              });

              const textNode = document.createTextNode(appliedText + " ");
              const svgElement = existingFacetHead.querySelector("svg");

              if(existingFacetHead && selectedFiltersBlock){
                existingFacetHead.insertBefore(textNode, svgElement);
                existingFacetHead.style.display = "flex";

                selectedFiltersBlock.insertBefore(existingFacetHead, ul);
              }
            }
          }

        }

        if (window.innerWidth < 768) {
          const selectedFiltersBlock = document.querySelector(".wizzy-selected-filters");
          const facetListBlock = document.querySelector(".wizzy-facet-list-block");
          const existingFacetHead = document.querySelector(".wizzy-facet-head.selected-filter");

          if (selectedFiltersBlock && facetListBlock && existingFacetHead) {
            existingFacetHead.addEventListener("click", () => {
              selectedFiltersBlock.classList.toggle("open");
              existingFacetHead.classList.toggle("open");
            });

            // facetListBlock.insertBefore(selectedFiltersBlock, facetListBlock.firstChild);

            const ul = selectedFiltersBlock.querySelector(".wizzy-selected-facet-list");
            const liItems = ul ? ul.querySelectorAll("li") : [];

            if (liItems.length > 0) {
              const appliedText = `${liItems.length} Applied Filter${liItems.length > 1 ? "s" : ""}`;

              existingFacetHead.childNodes.forEach(node => {
                const isTextNode = node.nodeType === Node.TEXT_NODE;
                const isNonSvgElement = node.nodeType === Node.ELEMENT_NODE && node.tagName !== "SVG";

                if (isTextNode || isNonSvgElement) {
                  existingFacetHead.removeChild(node);
                }
              });

              const textNode = document.createTextNode(appliedText + " ");
              const svgElement = existingFacetHead.querySelector("svg");

              if(existingFacetHead && selectedFiltersBlock){
                existingFacetHead.insertBefore(textNode, svgElement);
                existingFacetHead.style.display = "flex";

                selectedFiltersBlock.insertBefore(existingFacetHead, ul);
              }
            }
          }

        }





      }


      catch (error) {
        console.log("wizzy error", error);
      }

      return data;
    });


  };

  let scrollY = 0;

  function lockScroll() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

// // Observe body for class changes
// const body = document.body;

// const observer1 = new MutationObserver((mutationsList) => {
//     for (const mutation of mutationsList) {
//         if (mutation.attributeName === "class") {
//             const hasFiltersOverlay = body.classList.contains("wizzy-filters-overlay");

//             if (hasFiltersOverlay) {
//                 lockScroll();
//             } else {
//                 unlockScroll();
//             }
//         }
//     }
// });

// observer1.observe(body, { attributes: true });



  const targetNode = document.querySelector(".wizzy-body-end-wrapper");

  function updateBodyClass() {
    const autocompleteElement = targetNode?.querySelector(".wizzy-autocomplete-wrapper");
    const isOpen = autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex";

    if (isOpen) {
      document.body.classList.add("wizzy-autocomplete-open");
      document.documentElement.classList.add("wizzy-autocomplete-open");
      // lockScroll();
    } else {
      document.body.classList.remove("wizzy-autocomplete-open");
      document.documentElement.classList.remove("wizzy-autocomplete-open");
      // unlockScroll();
    }
  }

  const config = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style"]
  };

  const callback = function (mutationsList, observer2) {
    for (const mutation of mutationsList) {
      updateBodyClass();
      break;
    }
  };

  const observer = new MutationObserver(callback);

  if (targetNode) {
    observer.observe(targetNode, config);
    updateBodyClass();
  }


  if (window.innerWidth <= 768) {
    const front_input = document.querySelector("#header-search > input");

    front_input && front_input.addEventListener("click", function (e) {
      e.preventDefault();
      const back_input = document.querySelector("#search_mini_form input");
      back_input && back_input.click();
      let search_form = document.querySelector("#search_mini_form");
      search_form && (search_form.style.display = "block",
          setTimeout(() => {
                let search_bar = search_form.querySelector("input");
                search_bar && search_bar.click()
              }
              , 300));
      let autocomplete = document.querySelector(".wizzy-autocomplete-wrapper");
      autocomplete && (autocomplete.style.top = "83px")
    })
  }
}
catch (e) {
  console.log(e);
}